import * as yup from 'yup'
import { IntlShape } from 'react-intl'
import { PO_BOX_REGEX } from 'resources/constants'

const PASSWORD_MIN_LENGTH = 8

export interface FormValues {
  firstName: string
  lastName: string
  email: string
  password: string
  passwordRetype: string
  telephone: string
  birthYear?: string
  gender: string
  street: string
  city: string
  state: string
  zipCode: string
  community: string
  communityCode?: string
  communityName?: string[]
  accountType: string
  communitySelect?: string
}

export const schema = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordRetype: '',
  telephone: '',
  birthYear: '',
  gender: '',
  street: '',
  city: '',
  state: '',
  zipCode: '',
  community: '',
  communityCode: '',
  communityName: [''],
  accountType: '',
  communitySelect: ''
}

export const validation = (intl: IntlShape) => {
  const { formatMessage } = intl

  return yup.object().shape({
    email: yup
      .string()
      .email(formatMessage({ id: 'validation.emailValid' }))
      .required(formatMessage({ id: 'validation.emailValid' })),

    firstName: yup
      .string()
      .required(formatMessage({ id: 'validation.firstNameRequired' })),

    lastName: yup
      .string()
      .required(formatMessage({ id: 'validation.lastNameRequired' })),

    telephone: yup
      .string()
      .required(formatMessage({ id: 'validation.phoneRequired' })),

    birthYear: yup.string(),

    gender: yup.string(),

    street: yup
      .string()
      .matches(PO_BOX_REGEX, formatMessage({ id: 'validation.PoBox.invalid' }))
      .required(formatMessage({ id: 'validation.addressRequired' })),

    accountType: yup
      .string()
      .required(formatMessage({ id: 'validation.genericRequired' })),

    communitySelect: yup.string().when('accountType', {
      is: 'resident',
      then: yup
        .string()
        .required(formatMessage({ id: 'validation.genericRequired' })),
      otherwise: yup.string()
    }),

    community: yup.string().when('communitySelect', {
      is: 'communityNotListed',
      then: yup
        .string()
        .required(formatMessage({ id: 'validation.genericRequired' }))
    }),

    communityName: yup
      .array()
      .of(yup.string())
      .when('accountType', {
        is: 'employee',
        then: yup
          .array()
          .of(yup.string())
          .required(formatMessage({ id: 'validation.genericRequired' }))
      }),

    communityCode: yup.string().when('accountType', {
      is: 'employee',
      then: yup
        .string()
        .required(formatMessage({ id: 'validation.genericRequired' }))
    }),

    city: yup
      .string()
      .required(formatMessage({ id: 'validation.genericRequired' })),

    state: yup
      .string()
      .required(formatMessage({ id: 'validation.genericRequired' })),

    zipCode: yup
      .string()
      .required(formatMessage({ id: 'validation.genericRequired' })),

    password: yup
      .string()
      .required(formatMessage({ id: 'validation.passwordRequired' }))
      .min(
        PASSWORD_MIN_LENGTH,
        formatMessage({ id: 'validation.passwordMinLength' })
      )
      .matches(/[a-z]/, formatMessage({ id: 'validation.passwordLowercase' }))
      .matches(/[A-Z]/, formatMessage({ id: 'validation.passwordUppercase' }))
      .matches(/[0-9]/, formatMessage({ id: 'validation.passwordNumbers' })),

    passwordRetype: yup
      .string()
      .required(formatMessage({ id: 'validation.passwordRetype' }))
      .oneOf(
        [yup.ref('password'), null],
        formatMessage({ id: 'validation.passwordRetypeMatches' })
      )
  })
}
